import React, { useState } from "react";
import Link from "@/utils/link";
import Image from "next/legacy/image";

import { imageLoader } from "@/utils/image";
import Button from "@/ui/Button";

import GetStartedCreate from "@/components/Logo/GetStartedCreate";
import GetStartedUpdate from "@/components/Logo/GetStartedUpdate";
import GetStartedUpgrade from "@/components/Logo/GetStartedUpgrade";

import GetStartedBetterLeads from "@/components/Logo/GetStartedBetterLeads";
import GetStartedBetterTools from "@/components/Logo/GetStartedBetterTools";
import GetStartedMoney from "@/components/Logo/GetStartedMoney";
import GetStartedControl from "@/components/Logo/GetStartedControl";

import HomeOurValues from "@/components/home/HomeOurValues";
import { OurStory } from "@/components/home/HowItWorks";

import CpHomeHeader from "./CpHomeHeader";
import CpHomeFooter from "./CpHomeFooter";

const CpHowItWorks = () => {
    const items = [
        {
            title: "CREATE OR CLAIM COMMUNITY",
            Icon: GetStartedCreate,
            content: "",
            url: "https://portal.purpledoorfinders.com/community-portal",
        },
        {
            title: "UPDATE COMMUNITY",
            Icon: GetStartedUpdate,
            content: "",
            url: "https://portal.purpledoorfinders.com/community-portal",
        },
        {
            title: "MOVE-IN NOTIFICATION",
            Icon: GetStartedUpgrade,
            content: "",
            url: "https://portal.purpledoorfinders.com/community-portal",
        },
    ];

    return (
        <div className="">
            <CpHomeHeader fixed={true} />

            <div className="">
                <div className="hidden sm:block relative w-full h-40 sm:h-96 bg-gradient-to-r from-black via-black to-transparent">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/how-it-works-communities2"
                        alt="purple-door-finders-articles"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="0px -100px"
                        priority
                        unoptimized={false}
                        className="opacity-60"
                    />

                    <div className="relative container mx-auto px-4 sm:px-16 pt-32">
                        <h1 className="text-3xl sm:text-5xl text-white font-headline font-bold">
                            How It Works
                        </h1>

                        <p className="mt-4 text-white text-xl max-w-md">
                            Purple Door is a new online search platform where seniors and
                            their advocates can find senior and assisted living options
                            based on each senior's preferences or needs.
                        </p>
                    </div>
                </div>

                <div className="container mx-auto px-4 py-4 sm:px-16 sm:py-12">
                    <h3 className="text-3xl text-primary-500 font-bold font-headline">
                        Innovating a New Way for Marketing
                    </h3>

                    <div className="mt-8 grid grid-cols-1 xl:grid-cols-3 gap-x-16 gap-y-8">
                        <div>
                            <h4 className="text-lg text-primary-500 font-bold font-headline">
                                Transformative Listing Service for Senior Living
                            </h4>

                            <p className="mt-4">
                                Today, we are an internet-enabled culture where people want
                                to shop and compare without being sold to. Shoppers are used
                                to using websites to research and find what they are looking
                                for, whether they are buying a car, searching for a home, or
                                finding a pet sitter. Purple Door is the first and largest
                                comprehensive resource in the senior and assisted living
                                arena, providing a national listing service for communities
                                of all sizes. We provide shoppers with valuable real-time
                                information.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-lg text-primary-500 font-bold font-headline">
                                Dedicated to Transparency and Independence
                            </h4>

                            <p className="mt-4">
                                Purple Door was built for two reasons: to create the largest
                                nationwide online marketplace of senior and assisted living
                                options and to lower the cost of online lead generation for
                                communities. We put the best interests of residents and
                                communities over the standard online commission-based
                                referral agency models. All communities are invited to have
                                a presence on our website; therefore, there’s no bias toward
                                one community over another and no commission incentive based
                                on a community's base rental rate.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-lg text-primary-500 font-bold font-headline">
                                A Resource for ALL - Communities, Seniors, and Their
                                Advocates
                            </h4>

                            <p className="mt-4">
                                Purple Door is a nationwide listing service accessible to
                                communities of all sizes, from large-scale communities to
                                smaller residential board-and-care homes. This democratizes
                                the senior living search experience so that all communities
                                can choose to have an online presence on our marketplace.
                                Now, potential residents, seniors, and their advocates can
                                see most, if not all, of the assisted living and senior
                                living options in their search area.
                            </p>
                        </div>
                    </div>

                    <h2 className="mt-16 text-3xl text-primary-500 font-bold font-headline">
                        Claim or Add Your Community NOW!
                    </h2>

                    <div className="max-w-2xl">
                        <p className="mt-4 text-base">
                            To obtain the Membership Listing and become a member of the
                            Purple Door marketplace, simply claim or add your communities
                            and agree to our Terms of Use. Here’s how it works: when a
                            resident lead takes financial possession for a move-in, the
                            community pays our low annual Membership Listing fee. All other
                            move-ins in that year are included in the membership fee. The
                            Member Listing fee will automatically renew annually at the
                            current posted rate on our website.
                        </p>
                    </div>

                    <div className="mt-4 grid grid-cols-1 xl:grid-cols-3 gap-x-16 gap-y-8">
                        {items.map((item) => (
                            <Item key={item.title} {...item} />
                        ))}
                    </div>
                </div>

                <div className="py-12 bg-gray-200">
                    <div className="flex justify-center">
                        <Link href="https://meetings.hubspot.com/community49">
                            <a className="px-4 py-2 uppercase font-headline bg-primary-500 rounded text-white">
                                Schedule Demo
                            </a>
                        </Link>
                    </div>
                    <p className="mt-4 flex justify-center">
                        Or call a Purple Door expert today at 612-PURPLE-3
                    </p>
                </div>

                <PurpleDoorFindersIsTransforming />

                <OurStory />

                <HomeOurValues />
            </div>

            <CpHomeFooter />
        </div>
    );
};

const Item = ({ title, Icon, content, url }) => {
    return (
        <a
            href={url}
            className="flex items-center space-x-8 px-4 py-4 hover:bg-gray-light/50 rounded-xl"
        >
            <div>
                <Icon width={64} height={64} />
            </div>

            <div className="">
                <h3 className="text-lg text-primary-500 font-bold font-headline">
                    {title}.
                </h3>

                <p className="">{content}</p>
            </div>
        </a>
    );
};

const Promise = ({ title, children, Icon }) => {
    return (
        <div className="flex flex-col items-center">
            <Icon width={96} height={96} />
            <h3 className="mt-6 text-center text-primary-500 text-2xl font-headline font-bold uppercase">
                {title}
            </h3>
            <p className="mt-8 text-center text-lg">{children}</p>
        </div>
    );
};

export const PurpleDoorFindersIsTransforming = () => {
    return (
        <div className="w-full bg-gray-sec/50">
            <div className="container mx-auto px-8 sm:px-16">
                <div className="py-16">
                    <div className="flex justify-center">
                        <h2 className="max-w-5xl text-center text-primary-500 text-3xl font-headline font-bold">
                            Purple Door has transformed online lead generation for
                            communities
                        </h2>
                    </div>

                    <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-x-12 gap-y-8">
                        <Promise title="BETTER LEADS" Icon={GetStartedBetterLeads}>
                            Seniors and their advocates are better informed BEFORE they call
                            and schedule tours. They use our resources like “Needs
                            Assessment Tool, and “Financial Calculator” to better understand
                            what they should be looking for. THEN, they begin shopping and
                            compare options in their search area.
                        </Promise>

                        <Promise title="BETTER TOOLS" Icon={GetStartedBetterTools}>
                            Communities can manage their real-time listings, including
                            available vacancies, base rates, floor plans, move-in
                            incentives, and upcoming community events. They can showcase
                            their services, activities, amenities, menus, calendars, company
                            brochures, and much more with the Membership Listing. Resident
                            leads connect directly with the community using our “Request a
                            Tour & Ask a Question” features. Real-time vacancy postings and
                            lead flow can be seamlessly integrated with most
                            industry-standard CRM systems.
                        </Promise>

                        <Promise title="MORE AFFORDABLE" Icon={GetStartedMoney}>
                            Purple Door has a better way for communities to manage their
                            marketing budget and increase occupancy. Here’s how it works:
                            when a resident lead takes financial possession for a move-in,
                            the community pays our low annual Membership Listing fee. All
                            other move-ins in that year are included in the membership
                            Listing fee. The Membership Listing fee will automatically renew
                            annually. To obtain the Membership Listing and become a member
                            of the Purple Door marketplace, simply claim or add your
                            communities and agree to our terms of use.
                        </Promise>

                        <Promise title="MORE CONTROL" Icon={GetStartedControl}>
                            Our platform lets you manage and customize your profile—from
                            community details to availability, rates, and
                            incentives—individually or with our assistance, in greater
                            detail than anywhere else online. In addition, leads connect
                            directly with you, so you drive the conversation.
                        </Promise>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CpHowItWorks;
